import moment from 'moment';

export const addOffsetToDate = (dateIn) => {
  if (!dateIn) {
    return null;
  }
  const date = dateIn instanceof Date ? dateIn : new Date(dateIn);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const offset = date.getTimezoneOffset();
  const dateOut = new Date(date.getTime() + offset * 60 * 1000);
  return dateOut;
}

export const subOffsetFromDate = (dateIn) => {
  if (!dateIn) {
    return null;
  }
  const date = dateIn instanceof Date ? dateIn : new Date(dateIn);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const offset = date.getTimezoneOffset();
  const dateOut = new Date(date.getTime() - offset * 60 * 1000);
  return dateOut;
}

export const parseDateAndFormat = strDate => {
  if (!strDate) {
    return;
  }
  let date = moment(strDate, "YYYY-MM-DD").toDate();
  date = addOffsetToDate(date);
  return moment(date).format("DD/MM/YYYY");
}